import { watch } from 'vue'
import { useCodeStore } from '@/stores'

export function useCode() {
  /** キャンペーンコードのストア */
  const code = useCodeStore()

  // キャンペーンコードを監視
  watch(code, () => {
    // キャンペーンコードの中身が変更されたらLocalStorageと同期する
    code.store()
  })

  return { code }
}
